import React, { useMemo, useState, useEffect } from 'react'
import ModalForm from '../../../../components/compounds/modalForm/ModalForm.compunds'
import { ReactComponent as ClipIcon } from "../../../../design/assests/images/icons/paperclip.svg"
import SimpleMessage from '../../../../components/atoms/SimpleMessage.atom'
import VacationsReportTeamMemberDropdown from "../../../../components/molecules/VacationsReportTeamMemberDropdown"
import { InputText } from 'primereact/inputtext'
import InputCalendarForm from '../../../../components/molecules/InputCalendarForm.molecule'
import InputNumber from '../../../../components/atoms/InputNumber.atom'
import { checkAllFields, fieldsHaveErrors, isANumberGreaterThanZero, isNotEmpty, validateFieldValue } from '../../../../utils/validations.utils'
import Button from '../../../../components/atoms/Button.atom'
import useToast from '../../../../hooks/useToast.hook'
import { createAdditionalDaysPackage } from '../../../../services/vacation.service'
import TeamMemberVacationsAditionalTable from '../common/TeamMemberVacationsAditionalTable.controller'
import { DateTime } from 'luxon'
import { additionalDaysValidity } from '../../../../utils/vacation.utils'
import { isDateAtWeekend } from '../../../../utils/date.utils'


const initialStateNewAdditionalDay = {
    availableDays: 1,
    motive: '',
    expirationDate: null
}

const initialNewDayValidations = {
    availableDays: { value: initialStateNewAdditionalDay.availableDays, errors: [], typeValidations: [isANumberGreaterThanZero] },
    motive: { value: initialStateNewAdditionalDay.motive, errors: [], typeValidations: [isNotEmpty] },
    expirationDate: { value: initialStateNewAdditionalDay.expirationDate, errors: [], typeValidations: [isNotEmpty] }
}

const ModalFormAditionalDaysReview = ({
    visible = false,
    setVisible = () => {},
    selectedTeamMember = {},
    activeTeamMember= {},
    setActiveTeamMember, 
    triggerRefresh,
    refresh = false
}) => {
   
    const { setErrorMessage, setSuccessMessage } = useToast()
    const [newAdditionalDay, setNewAdditionalDay] = useState(initialStateNewAdditionalDay)
    const [newAdditionalDayValidations, setNewAditionalDayValidations] = useState(initialNewDayValidations)
    
    const hasActiveTeamMember = Boolean(activeTeamMember?.idTeamMember)
    const [cameFromTeamMemberDropdown, setCameFromTeamMemberDropdown] = useState(false)


    const period = () => {
        const startDate = activeTeamMember?.currentPeriod?.start
        const workAnniversaryDate = activeTeamMember?.userWorkAnniversary
        const formattedStartDate = startDate ? DateTime.fromFormat(startDate, 'dd/MM/yyyy').toFormat('yyyy-MM-dd') : null
        const endDateNextAnniversary = additionalDaysValidity(formattedStartDate).maxDate?.toFormat('yyyy-MM-dd')
        const formattedWorkAnniversaryDate = workAnniversaryDate ? DateTime.fromISO(workAnniversaryDate.split('T')[0]).toFormat('yyyy-MM-dd') : null
        return { startDate: formattedStartDate, endDateNextAnniversary, workAnniversary: formattedWorkAnniversaryDate}
    }

    useEffect(() => {
        if (!selectedTeamMember || !selectedTeamMember.idTeamMember) {
            setActiveTeamMember(null)
            setCameFromTeamMemberDropdown(false)
            setNewAdditionalDay(initialStateNewAdditionalDay)
            setNewAditionalDayValidations(initialNewDayValidations)
        } else if (selectedTeamMember.idTeamMember !== activeTeamMember?.idTeamMember) {
            setActiveTeamMember(selectedTeamMember)
            setCameFromTeamMemberDropdown(false)
            setNewAdditionalDay(initialStateNewAdditionalDay)
            setNewAditionalDayValidations(initialNewDayValidations)
        }
    }, [selectedTeamMember])


const handleTeamMemberSelect = (member) => {

  setActiveTeamMember(member) 
  setCameFromTeamMemberDropdown(true)
}

    const handleChange = ( name, value ) => {
        setNewAditionalDayValidations(validateFieldValue(newAdditionalDayValidations, name, value))
        setNewAdditionalDay(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async () => {
        checkAllFields(newAdditionalDayValidations, setNewAditionalDayValidations)
        if (fieldsHaveErrors(newAdditionalDayValidations) || !activeTeamMember?.idTeamMember) return
        try {
            const newDay = {
            ...newAdditionalDay,
            motive: newAdditionalDay.motive.trim(),
            idTeamMember: activeTeamMember.idTeamMember,
            expirationDate: newAdditionalDay.expirationDate.toFormat('yyyy-MM-dd')
        }
          const response = await createAdditionalDaysPackage(newDay)
          if(!response.success){
           return setErrorMessage({message: response.message || 'No se pudieron agregar los días adicionales', lifeTime: 3000})
          }

          setSuccessMessage({message: 'Días adicionales agregados con éxito', lifeTime: 3000})
          setNewAdditionalDay(initialStateNewAdditionalDay)
          triggerRefresh()   
    
        } catch (error) {
            setErrorMessage({message: error.message || 'No se pudieron agregar los días adicionales', lifeTime: 3000})
        }
    }

    const isButtonSaveDisabled = useMemo(() => {
        const validAvailableDays = !isNaN(newAdditionalDay.availableDays) && newAdditionalDay.availableDays > 0
        const validMotive = typeof newAdditionalDay.motive === "string" && newAdditionalDay.motive.trim().length > 0
        const validExpirationDate = newAdditionalDay.expirationDate && newAdditionalDay.expirationDate.isValid
        const hasTeamMemberSelected = Boolean(activeTeamMember?.idTeamMember)
        return !(validAvailableDays && validMotive && validExpirationDate && hasTeamMemberSelected)
    }, [newAdditionalDay.motive, newAdditionalDay.availableDays, newAdditionalDay.expirationDate, activeTeamMember?.idTeamMember])

    const header = (
        <div className='flex gap-3 align-items-center'>
            <ClipIcon />
            <div className='flex flex-column gap-2'>
                <span className="text-3xl font-semibold font-cairo line-height-1">
                    {hasActiveTeamMember  ? "Días adicionales" : "Nuevo día adicional"}
                </span>
                {hasActiveTeamMember  && (
                <span className="font-weight-400 font-size-16">
                    {selectedTeamMember.userName}
                </span>
                )}
            </div>
        </div>
    )


  return (
    <ModalForm
        header={header}
        headerIcon={<ClipIcon />}
        visible={visible}
        setVisible={setVisible}
        closable
        withoutFooter
        className="aditional-days-modal"
        cleanUp={() => {
            setNewAdditionalDay(initialStateNewAdditionalDay)
            setNewAditionalDayValidations(initialNewDayValidations)
        }}
    >
         <SimpleMessage
          severity="warn"
          text={'En caso de editar o eliminar un día adicional, deberás informar al integrante sobre la modificación.'}
        />
        {(!activeTeamMember || cameFromTeamMemberDropdown) && (
            <div className="mt-3 flex flex-column gap-2 w-full">
            <label>
                Selecciona un integrante:
            </label>
                <VacationsReportTeamMemberDropdown
                    optionValue="userId"
                    selectedTeamMember={activeTeamMember}
                    setSelectedTeamMember={handleTeamMemberSelect}
                />
            </div>
        )}
        <div className='mt-3 mb-2'>Agregar días adicionales</div>
        <div className="additional-days-form mb-3">
            <div className="quantity-field">
                <InputNumber
                    showButtons
                    step={1}
                    value={newAdditionalDay.availableDays}
                    onChange={(e) => handleChange('availableDays', e.value)}
                    min={1}
                />
            </div>
            <div className="motive-field">
                <InputText
                    placeholder='Motivo'
                    value={newAdditionalDay.motive}
                    onChange={(e) => handleChange('motive', e.target.value)}
                />
            </div>
            <div className="validity-field">
                <InputCalendarForm
                    placeholder='Vigencia'
                    value={newAdditionalDay.expirationDate}
                    onChange={(date) => handleChange('expirationDate', date)}
                    minDate={additionalDaysValidity(period().startDate).minDate}
                    maxDate={additionalDaysValidity(period().startDate).maxDate}
                    disabledDate={(current) => isDateAtWeekend(current)}
                />
            </div>
            <div className="button-field">
                <Button
                    icon="pi pi-plus"
                    className="p-button-success border-circle flex-shrink-0"
                    onClick={handleSubmit}
                    disabled={isButtonSaveDisabled}
                    style={isButtonSaveDisabled ? { background: 'var(--secondary-color-highlight, #CDD4DE)', border: 'none', boxShadow: 'none' } : {}}
                />
            </div>
        </div>
        <TeamMemberVacationsAditionalTable
            teamMemberId={activeTeamMember?.idTeamMember}
            periodStartDate={period().startDate}
            periodEndDate={period().endDateNextAnniversary}
            workAnniversary={period().workAnniversary}
            refresh={refresh}
            editable
            triggerRefresh={triggerRefresh}
        />
    </ModalForm>
    
  )
}

export default ModalFormAditionalDaysReview
